import clsx from "clsx";
import { isApplePlatform } from "@/lib/hooks";
import styles from "./Kbd.module.css";

const APPLE_SYMBOLS: Record<string, string> = { mod: "⌘", shift: "⇧", alt: "⌥", ctrl: "⌃", enter: "↩", escape: "esc" };
const OTHER_NAMES: Record<string, string> = {
  mod: "Ctrl",
  shift: "Shift",
  alt: "Alt",
  ctrl: "Ctrl",
  enter: "Enter",
  escape: "Esc",
};

/** Platform label for a key name: "mod" is ⌘ on Apple platforms and Ctrl elsewhere. */
export function keyLabel(key: string, apple = isApplePlatform()): string {
  const names = apple ? APPLE_SYMBOLS : OTHER_NAMES;
  return names[key.toLowerCase()] ?? (key.length === 1 ? key.toUpperCase() : key);
}

export interface KbdProps {
  /** Key names in order, e.g. ["mod", "k"] renders ⌘K on a Mac and Ctrl K elsewhere. */
  keys: string[];
  className?: string;
}

/** A keyboard shortcut hint (menus, the palette trigger, tooltips). */
export function Kbd({ keys, className }: KbdProps) {
  const apple = isApplePlatform();
  return (
    <kbd className={clsx(styles.kbd, className)}>
      {keys.map((key, index) => (
        <kbd key={`${index}-${key}`} className={styles.key}>
          {keyLabel(key, apple)}
        </kbd>
      ))}
    </kbd>
  );
}
